import ActionTypes from '../constants/ActionTypes';

export const getUserType = () => ({
  type: ActionTypes.GET_USER_TYPE,
});

export const getRecruiter = () => ({
  type: ActionTypes.GET_RECRUITER,
});

export const getHacker = () => ({
  type: ActionTypes.GET_HACKER,
});
